import { DeckType } from '../model/DeckType';
import * as firestoreClient from '../script/firestore-client'

const table = 'deck_type'

export async function list(): Promise<DeckType[]> {
  return await firestoreClient.listFromCache(table, undefined, [{key: 'kana', condition: 'asc'}]) as DeckType[]
}

export async function listFromCache(
  filterOps?: firestoreClient.FilterOption[],
  sortOps?: firestoreClient.SortOption[],
  limit?: number
): Promise<DeckType[]> {
  return await firestoreClient.listFromCache(table, filterOps, sortOps, limit) as DeckType[]
}

export function save(deckType: DeckType) {
  firestoreClient.saveWithAssignId(table, deckType)
}